import { showMessage } from "@src/domains/shared/helpers/messageHelper";
import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";

const RELOAD_DELAY_MS = 1000;

export function VersionUpdateNotice() {
  const toastRef = useRef<Toast>(null);

  useEffect(() => {
    showMessage(toastRef, "info", "Neue Version wird geladen...");

    const timeoutId = window.setTimeout(() => {
      window.location.reload();
    }, RELOAD_DELAY_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, []);

  return <Toast ref={toastRef} position="bottom-right" />;
}
